var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-message-box boss-message-box-received" },
    [
      _c("img", {
        staticClass: "boss-message-box-avatar boss-message-box-avatar-user",
        attrs: { src: require("@/assets/images/boss-avatar.svg") },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "boss-message-header-layout" }, [
        _c(
          "div",
          {
            staticClass: "boss-layout-block boss-message-when",
            attrs: { "data-test": "date" },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm._f("formatDate")(_vm.date)) + "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-layout-block" }, [
        _c(
          "div",
          {
            staticClass: "boss-message-mail-subject",
            attrs: { "data-test": "subject" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("formatSubject")(_vm.subject)) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "boss-message-mail-body pega-pre-wrap",
          attrs: { "data-test": "body" },
          domProps: { innerHTML: _vm._s(_vm.$sanitize(_vm.renderBody)) },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-message-last-button-block" }, [
        _c(
          "a",
          {
            staticClass: "boss-button",
            attrs: { href: "javascript:void(0)", "data-test": "quote-message" },
            on: { click: _vm.setBodyAndSubject },
          },
          [_vm._v("メッセージを引用してメールを作成")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }